const login = 'AUTH_LOGIN';
const logout = 'AUTH_LOGOUT';
const additionalInformationRecieved = 'ADDITIONAL_INFORMATION_RECEIVED';
const selectedCustomerChanged = 'SELECTED_CUSTOMER_CHANGED';
const tenantInformationRequesting = 'REQUESTING_TENANT_INFORMATION';
const tenantInformationReceived = 'TENANT_INFORMATION_RECEIVED';
const monitoringInformationRequesting = 'MONITORING_TENANT_INFORMATION';
const monitoringInformationReceived = 'MONITORING_INFORMATION_RECEIVED';
const setThemeState = 'SET_THEME';
const initialState = { userName: "", customers: [], activeCustomerId: 0, name: "", firstName: "", lastName: "", isAuthenticated: false, isAuthorized: false, isLoading: true, initials: "", oid: "", permissions: [], accountDeletionRequestDate: null, accountDeletionDate: null, azureTenants: [], requestingTenantData: true, monitoringLocation: "", runAsUser: null, defaultActionId: null, theme: null };

export const actionCreators = {

	init: () => async (dispatch) => {

		//dispatch({ type: logout, userName: "", isAuthenticated: false });

		const url = '/account/me';
		const response = await fetch(url);
		if (response.ok) {

			const me = await response.json();
			var state = {
				userName: me.userName,
				isAuthenticated: me.isAuthenticated,
				isAuthorized: me.isAuthorized,
				unauthorizedMessage: me.unauthorizedMessage,
				initials: me.initials,
				permissions: me.permissions,
				oid: me.oid,
				name: me.fullName,
				firstName: me.firstName,
				lastName: me.lastName,
				activeCustomerId: me.activeCustomerId,
				runAsUser: me.runAsUser,
				defaultActionId: me.defaultActionId,
				roles: me.roles,
				theme: me.theme
			};

			dispatch({ type: login, ...state });
		}
		// call acount/me every 10 minutes to keep session alive
		setInterval(async () => {
			await fetch('/account/me');
		}, 600000);
	},
	getAdditionalInformation: () => async (dispatch) => {

		const url = '/api/account';
		const response = await fetch(url);
		const me = await response.json();
		if (response.ok) {
			dispatch({ type: additionalInformationRecieved, accountDeletionRequestDate: me.accountDeletionRequestDate, accountDeletionDate: me.accountDeletionDate });
		}
	},
	getAzureTenants: () => async (dispatch) => {

		dispatch({
			type: tenantInformationRequesting
		});

		return new Promise(async (resolve) => {

			const url = '/api/account/tenants';

			await fetch(url)
				.then(response => response.json())
				.then((data) => {
					const tenantData = data;
					dispatch({
						type: tenantInformationReceived,
						azureTenants: tenantData
					});
					resolve();
				});
		});
	},
	getMonitoringInformation: () => async (dispatch) => {

		dispatch({
			type: monitoringInformationRequesting
		});

		return new Promise(async (resolve) => {

			const url = '/api/managedservices/monitoring';

			var response = await fetch(url);

			if (response.ok) {
				var data = await response.json();
				dispatch({
					type: monitoringInformationReceived,
					monitoringLocation: data.monitoringLocation
				});
				resolve();
			}
		});
	},
	setCustomerInformation: (customerId) => async (dispatch) => {

		return new Promise(async (resolve) => {
			const url = 'api/account/activecustomer';
			var json = { customerId: customerId };
			await fetch(url, {
				method: 'POST',
				body: JSON.stringify(json),
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(() => {
				dispatch({ type: selectedCustomerChanged, activeCustomerId: customerId });

				resolve();
			});
		});
	},

	setTheme: (themeName) => (dispatch) => {
		dispatch({ type: setThemeState, themeName: themeName })
    }
};

export const reducer = (state, action) => {
	state = state || initialState;

	if (action.type === login) {
		return {
			...state,
			userName: action.userName,
			name: action.name,
			isAuthenticated: action.isAuthenticated,
			isAuthorized: action.isAuthorized,
			unauthorizedMessage: action.unauthorizedMessage,
			isLoading: false,
			oid: action.oid,
			initials: action.initials,
			activeCustomerId: action.activeCustomerId,
			permissions: action.permissions,
			firstName: action.firstName,
			lastName: action.lastName,
			runAsUser: action.runAsUser,
			defaultActionId: action.defaultActionId,
			roles: action.roles,
			theme: action.theme
		};
	}

	if (action.type === logout) {
		return {
			...state,
			userName: "",
			name: "",
			isAuthenticated: action.isAuthenticated,
			isAuthorized: false,
			unauthorizedMessage: "",
			oid: "",
			initials: "",
			permissions: [],
			customers: []
		};
	}

	if (action.type === additionalInformationRecieved) {
		return {
			...state,
			accountDeletionRequestDate: action.accountDeletionRequestDate,
			accountDeletionDate: action.accountDeletionDate
		};
	}

	if (action.type === selectedCustomerChanged) {
		return {
			...state,
			activeCustomerId: action.activeCustomerId
		};
	}
	if (action.type === tenantInformationRequesting) {
		return {
			...state,
			requestingTenantData: true
		};
	}
	if (action.type === tenantInformationReceived) {
		return {
			...state,
			azureTenants: action.azureTenants,
			requestingTenantData: false
		};
	}
	if (action.type === monitoringInformationReceived) {
		return {
			...state,
			monitoringLocation: action.monitoringLocation
		};
	}
	if (action.type === setThemeState) {
		return {
			...state,
			theme: action.themeName
		};
	}
	return state;
};


// WEBPACK FOOTER //
// ./src/store/Account.js